import {ThemingStore} from "./store/ThemingStore";

const ModuleName = "tfApp.theming";

export default angular.module(ModuleName, [])
                      .service(ThemingStore.id, ThemingStore)
                      .name;
